import React from 'react';
import classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {BREAKPOINTS} from 'utilities';
import {SubscriptionForm} from 'components/Marketplace/SubscriptionForm';
import {Flex, Text, Section} from 'components/UIKit';
import {ImageOptions, PictureData, Picture} from 'components/UIKit/Picture';
import styles from './SubscriptionLayout.scss';
import {defaultPictureData} from './images';
import * as locales from './locales';

export interface SubscriptionLayoutProps {
  fallbackPictureData?: PictureData;
  authenticityToken: string;
  className?: string;
  imageUrl?: string;
  subhead?: string;
}

const imageOptions: ImageOptions[] = [
  {
    breakpoint: BREAKPOINTS.mobile,
    fallback: true,
    options: {
      width: 414,
      height: 196,
    },
  },
  {
    breakpoint: BREAKPOINTS.tablet,
    options: {
      width: 464,
      height: 309,
    },
  },
  {
    breakpoint: BREAKPOINTS.desktopUp,
    options: {
      width: 800,
      height: 379,
    },
  },
];

export class SubscriptionLayoutComponent extends React.Component<
  SubscriptionLayoutProps & WithI18nProps
> {
  renderSubscriptionHeading = () => {
    const {i18n} = this.props;
    return (
      <Text
        type="h2"
        component="h3"
        text={i18n.translate('heading')}
        align="inherit"
        inheritColor
      />
    );
  };

  renderSubscriptionSubhead = () => {
    const {subhead, i18n} = this.props;
    return (
      <Text
        text={subhead || i18n.translate('subhead')}
        align="inherit"
        type="subhead2"
        inheritColor
      />
    );
  };

  render() {
    const {fallbackPictureData, authenticityToken, className, imageUrl} = this.props;

    return (
      <Flex className={classNames(styles.Container, className)}>
        <div className={styles.ImageContainer}>
          <Picture
            pictureClassName={styles.Image}
            imageUrl={imageUrl}
            pictureData={fallbackPictureData || defaultPictureData}
            imageOptions={imageOptions}
            alt=""
            lazyload
          />
        </div>

        <Section className={styles.Wrapper}>
          <SubscriptionForm
            authenticityToken={authenticityToken}
            centre={false}
            disclaimer
            renderHeading={this.renderSubscriptionHeading}
            renderSubhead={this.renderSubscriptionSubhead}
            backgroundColor="purpleDark"
          />
        </Section>
      </Flex>
    );
  }
}

export const SubscriptionLayout = withI18n({
  id: 'SubscriptionLayout',
  fallback: locales.en,
})(SubscriptionLayoutComponent);
